<app-d-form-group (control)="tcDetailFormControl = $event" [formArray]= "tcDetailForm"></app-d-form-group>
